export enum PackageParamTypes {
  RANGE = 'RANGE',
  SIZE = 'SIZE',
  QUANTITY = 'QUANTITY',
  ADVANCED_NOTICE = 'ADVANCED NOTICE',
}

export enum CategoriesPackage {
  SERVICE = 'SERVICE',
  PRODUCT = 'PRODUCT',
  AMENITY = 'AMENITY',
}
